import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { ReusableModal } from "ui/molecules/modal/ReusableModal";
import CreateBowelMovementForm, {
  BowelMovementFormHandle,
} from "../templates/CreateBowelMovementForm";
import { Button, ButtonText } from "ui/gluestack/button";
import { View } from "ui/atoms/view";

interface Ref {
  show: () => void;
}

const CreateBowelMovementModal = forwardRef<Ref, unknown>((_, ref) => {
  const [showing, setShowing] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  useImperativeHandle(ref, () => ({
    show: () => {
      setShowing(true);
    },
  }));
  const handleClose = useCallback(() => {
    setShowing(false);
  }, []);
  const formRef = useRef<BowelMovementFormHandle>(null);
  const renderFooter = useCallback(() => {
    return (
      <View className="col-span-full right-10 mt-2">
        <View className="flex flex-row justify-end gap-x-4">
          <Button
            action="primary"
            size="sm"
            variant="outline"
            onPress={handleClose}
          >
            <ButtonText>Cancel</ButtonText>
          </Button>
          <Button
            action="primary"
            size="sm"
            onPress={formRef?.current?.submitForm}
            disabled={isSubmitting}
          >
            <ButtonText className="text-white">Log Bowel Movement</ButtonText>
          </Button>
        </View>
      </View>
    );
  }, [isSubmitting, handleClose]);

  return (
    <ReusableModal
      isVisible={showing}
      onClose={handleClose}
      className="w-full max-w-[984px] mx-auto"
      title="Bowel Movement Log"
      footer={renderFooter()}
      hasCancelButton
    >
      <CreateBowelMovementForm
        onClose={handleClose}
        onSubmittingChange={setIsSubmitting}
        ref={formRef}
      />
    </ReusableModal>
  );
});

CreateBowelMovementModal.displayName = "CreateBowelMovementModal";
export { CreateBowelMovementModal };
